
  import { Component, Vue } from 'vue-property-decorator';
  import pluralize from 'pluralize-ru';
  import _ from 'lodash';
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IAppErrorPopup} from "@/modules/Popup/interfaces/app-error-popup.interface";

  @Component({})
  export default class TheDialogError extends Vue {
    openTabs = [];

    get storeState(): IAppState { return this.$store.state; }
    get stateError(): IAppErrorPopup.IState { return this.storeState.error; }
    get isVisible () { return this.stateError.isVisible; }
    get textRequest () { return this.stateError.requestData; }
    get isCustomTextAndReloadPage() { return this.stateError.textId === 'error.customTextAndReload'; }
    get isAddingReservedSidesError() { return !this.isNetworkError && !this.isCustomTextAndReloadPage; }

    get text() {
      let text;

      if (this.stateError.textId === 'error.customText' || this.isCustomTextAndReloadPage) {
        text = this.stateError.payload;

      } else if (this.stateError.payload !== null) {

        const count = this.stateError.payload;
        text = pluralize(
          count,
          '',
          this.$t(this.stateError.textId + '.1'),
          this.$t(this.stateError.textId + '.2'),
          this.$t(this.stateError.textId + '.5')
        );
        if (this.stateError.countSidesToAdd !== null && (count !== 1 || this.stateError.countSidesToAdd > 0)) {
          let endText = pluralize(
            this.stateError.countSidesToAdd,
            '',
            this.$t('error.freeSidesToAdd.1'),
            this.$t('error.freeSidesToAdd.2'),
            this.$t('error.freeSidesToAdd.5'),
          );
          text = endText;
        }
        if (this.stateError.countSidesToAdd === 0 && count !== 1) {
          text = `Не удалось добавить все ${count} свободных РП, т.к они были уже забронированы в другом заказе. Пожалуйста выберите другие РП!`;
        }

      } else {
        text = this.$t(this.stateError.textId);
      }

      return text;
    }

    get textResponse () {
      if (_.isString(this.stateError.responseData)) {
        return this.stateError.responseData;
      }
      return JSON.stringify(this.stateError.responseData);
    }

    get isNetworkError() {
      return this.stateError.textId === 'error.openLater' ||
        this.stateError.textId === 'error.reloadPage'||
        this.stateError.textId === 'error.contactsAgain'||
        this.stateError.textId === 'error.placeAgain'||
        this.stateError.textId === 'error.changeEmail'||
        this.stateError.textId === 'error.confirmEmail'||
        this.stateError.textId === 'error.changePassword'||
        this.stateError.textId === 'error.createNewUser'||
        this.stateError.textId === 'error.changeProfileContacts'||
        this.stateError.textId === 'error.requireHelpError'||
        this.stateError.textId === 'error.accreditationFilesSendError'||
        this.stateError.textId === 'error.sidesProlongFailed.otherError' ||
        this.stateError.textId === 'error.sidesReplaceFailed.otherError' ||
        this.stateError.textId === 'error.sidesRemoveFailed.otherError' ||
        this.stateError.textId === 'error.sidesAddFailed.otherError';
    }

    mounted() {
      window.addEventListener('keydown', this.onKeyPress);
    }

    goToHome() {
      const payload = {
        routeName : ROUTE_NAME.REDIRECT,
        url: window.location.href,
      };
      return this.$store.dispatch('openPage', payload)
    }

    resetFilterAndCloseError() {
      return this.$store.dispatch('filter/reset')
        .then(() => this.$store.dispatch('error/close'))
        .then(() => this.$store.dispatch('filter/filter'));
    }

    handleClose() {
      if (!this.isNetworkError) {
        return this.$store.dispatch('error/close');
      }
    }

    onKeyPress(event) {
      if (event.keyCode === 13) {
        this.handleClose();
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false;
        event.cancelBubble = true;
        return false;
      }
    }

    destroyed() {
      window.removeEventListener('keydown', this.onKeyPress);
    }
  }
